import React, {Component} from "react";
import asia from  '../../../Assets/img/asia.png'
import africa from  '../../../Assets/img/africa.png'
import america from  '../../../Assets/img/america.png'
import australia from  '../../../Assets/img/australia.png'
import europe from  '../../../Assets/img/europe.png'
import './Encyclopedia.css' 
import Header from '../../Hoc/Header'
import Footer from '../../Hoc/Footer'
import {Link} from 'react-router-dom'




export default class Continents extends Component{

    render() {
        return(
            
           <>
           <div className="Continents">
             <Header title="لیست قاره ها"/>

                <div className="Continents-body">

               




                   <div className="continents-wrapper">

                       
            <Link to={`/countries/asia`}>
            <div className="Continent-box1">
            </div>
            </Link>


            <Link to={`/countries/europe`}>
            <div className="Continent-box2">

            </div>
            </Link>


            <Link to={`/countries/africa`}>
            <div className="Continent-box3">

            </div>
            </Link>



            <Link to={`/countries/australia`}>
            <div className="Continent-box4">

            </div>
            </Link>



            <Link to={`/countries/america`}>
            <div className="Continent-box5">

            </div>
            </Link>        

                   

                     
                   </div>



                    <Footer/>
                </div>


             
           </div>
           


           

           

            </>
        )
    }
}
